<script lang="ts">
import { getWidgetFieldProps } from '@widgets/shared/compositions/field'
import WidgetFieldText, { widgetFieldTextProps } from '@widgets/shared/components/fields/WidgetFieldText.vue'
import { widgetFormFieldProps } from '@widgets/shared/components/fields/types'
import { mergeProps, defineComponent, h } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    ...widgetFormFieldProps,
    ...widgetFieldTextProps,
  },
  setup(props, context) {
    return () => {
      const fieldProps = getWidgetFieldProps(props.name!)
      return h(WidgetFieldText, mergeProps(props, context.attrs, fieldProps))
    }
  },
})
</script>
